<template>

      <Layout />

</template>

<script setup>
import Layout from "@/layout/index.vue";
import {onMounted} from 'vue'
import {useRoute, useRouter } from 'vue-router';
const router = useRouter();

onMounted(()=>{

  let flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)|| (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    if (!flag) {
      router.replace('/login');
    } 
  }) 



</script>

<style>
* {
  margin: 0;
  padding: 0;
}



html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  -webkit-touch-callout:none;/*系统默认菜单被禁用*/
	-webkit-user-select:none;/*webkit浏览器*/
	-khtml-user-select:none;/*早起浏览器*/
	-moz-user-select:none;/*火狐浏览器*/
	-ms-user-select:none;/*IE浏览器*/
	user-select:none;/*用户是否能够选中文本*/
}
#app {
  width: 100%;
  height: 100%;
}
</style>
